/**
 * API shapes → display values for the pipeline trigger UI.
 */

/** Shown when the service answers 200 but the body is not the expected shape. */
export const PIPELINE_UNEXPECTED_RESPONSE_MESSAGE =
  "The graph build service returned an unexpected response. Please try again.";

/**
 * HTTP failure → plain-language message for the status pill.
 * Raw response bodies are never shown to the user (logged dev-only instead);
 * `status === null` means the service could not be reached at all.
 */
export const toPipelineErrorMessage = (status: number | null): string => {
  if (status === null) {
    return "Can't reach the graph build service. Please check it is running and try again.";
  }
  if (status === 401 || status === 403) {
    return "You don't have permission to start a graph build.";
  }
  if (status === 409) {
    return "A graph build is already in progress. Please wait for it to finish.";
  }
  if (status === 400 || status === 422) {
    return "The build request was rejected. Please refresh the page and try again.";
  }
  if (status >= 500) {
    return "The graph build service ran into a problem. Please try again in a moment.";
  }
  return "Couldn't start the graph build. Please try again.";
};

/** ISO timestamp → short local time ("4:13 PM"); empty string when absent/invalid. */
export const formatPipelineTime = (
  isoTimestamp: string | null | undefined,
): string => {
  if (!isoTimestamp) {
    return "";
  }
  const date = new Date(isoTimestamp);
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  return date.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
  });
};
